import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";

export default function Instituition({ searchObject, onChange, t }) {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    CommonService.getAllSchools().then((data) => setSchools(data));
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Institution")}</legend>{" "}
      <Select
        className="form-select fontsize-legend"
        name="InstitutionId"
        onChange={onChange}
        value={searchObject.InstitutionId || ""}
      >
        <option value=""></option>
        {schools.map((school) => (
          <option
            className="fontsize-legend"
            key={school.id}
            value={school.description}
          >
            {t(school.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
